import script from "./MdTableRowGhost.vue?vue&type=script&lang=js"
export * from "./MdTableRowGhost.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__